import apiHelper from "../../../services/apiHelper";
import Club from "../models/Club";

const ClubService = {
  getClub: (id) => {
    return apiHelper.fetch('/crunch_core/clubs/' + id)
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to get cancellation status');
        }
        return response.json();
      }).then(data => new Club(data));
  },
  getAllClubs: () => {
    return apiHelper.fetch('/crunch_core/clubs')
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to get cancellation status');
        }
        return response.json();
      }).then(data => Club.fromArray(data));
  }
}

export default ClubService;